module.exports = __webpack_public_path__ + "img/product_86.b4259ac.webp";